module.exports = __webpack_public_path__ + "img/newspaper.578e1181.svg";